// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Set1","icon":"styles_icon__3pCry"};